import { render, staticRenderFns } from "./IconServerError.vue?vue&type=template&id=3da6c3c8&scoped=true"
import script from "./IconServerError.vue?vue&type=script&lang=js"
export * from "./IconServerError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da6c3c8",
  null
  
)

export default component.exports